import React from 'react'
import { Grid, useMediaQuery } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import { useTheme } from '@mui/material/styles'

export function SkeltonButton() {
  const theme = useTheme()
  const isPcScreen = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <Grid alignItems="center" container={true} direction="column" justifyContent="center">
      <Grid alignItems="flex-start" container={true} direction="column" justifyContent="flex-start">
        <Skeleton width={isPcScreen ? '25%' : '45%'} variant="rectangular" height={37} />
      </Grid>
    </Grid>
  )
}
